export { default as AuthSignInPage } from './Auth/SignIn/AuthSignInPage';
export { default as HomePage } from './Home/HomePage';
export { default as ReportsPage } from './Reports/ReportsPage';



// WEBPACK FOOTER //
// ./src/pages/index.js